import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-executive-council',
  templateUrl: './executive-council.component.html',
  styleUrls: ['./executive-council.component.scss']
})
export class ExecutiveCouncilComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
